// extracted by mini-css-extract-plugin
export var actionButton = "_8z-1";
export var actionButtons = "_8z-2";
export var actions = "_8z-0";
export var aiUnread = "_8z-10";
export var alignCenter = "_8z-h";
export var backWrapper = "_8z-3";
export var cellContainer = "_8z-4";
export var checkboxContainer = "_8z-5";
export var contentContainer = "_8z-6";
export var contentHeader = "_8z-8";
export var conversationsTableWrapper = "_8z-s";
export var draftReplyBadgeContainer = "_8z-m";
export var dropdownItem = "_8z-b";
export var dropdownItemsContainer = "_8z-a";
export var dropdownTitle = "_8z-c";
export var errorIcon = "_8z-7";
export var filter = "_8z-d";
export var gray = "_8z-i";
export var headerActionButtons = "_8z-e";
export var headerCheckboxContainer = "_8z-f";
export var icon = "_8z-j";
export var menuContainer = "_8z-k";
export var noMoreTicketsIcon = "_8z-12";
export var noMoreTicketsSubText = "_8z-13";
export var oneLine = "_8z-l";
export var optionsButton = "_8z-n";
export var plus = "_8z-o";
export var portalButtonsWrapper = "_8z-g";
export var red = "_8z-p";
export var scrolledTop = "_8z-9";
export var search = "_8z-q";
export var selectedConversationsCount = "_8z-r";
export var spinner = "_8z-t";
export var strong = "_8z-u";
export var summaryCell = "_8z-v";
export var tableContainer = "_8z-11";
export var tagContainer = "_8z-w";
export var threeDots = "_8z-x";
export var twoLines = "_8z-y";
export var unread = "_8z-z";